import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Modal from 'react-responsive-modal';
import { InputText } from 'primereact/inputtext';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { TabView, TabPanel } from 'primereact/tabview';
import SimpleReactValidator from 'simple-react-validator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import Select from 'react-select';
var deleteList = [], disableList = [];
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var svValidator;
var engValidator;
var engUserInfoValidator;
var svUserInfoValidator;
class UserAuthListComponent extends Component {
    constructor(props) {
        super(props);
        this.settingValidator = new SimpleReactValidator();
        this.toggleAll = this.toggleAll.bind(this);
        this.onDeleteClick = this.onDeleteClick.bind(this);
        this.permissionType=this.permissionType.bind(this)
        this.actionColumn = this.actionColumn.bind(this);
        this.state = {

            open: false,

            errorDisable: '',
            openModal: false,
            RegionId: '',
            heartRunnerDetails: {
                UserId: 0,
                AuthTypeId: 0,
                AuthMethodId: [],
                AuthMethodList: []
            },

        };
        this.baseState = this.state
    }
    componentWillMount() {
        SimpleReactValidator.addLocale('en', {
            required: 'The :attribute field is required.',
            min: 'The :attribute must be at least :min:type.',
            max: 'The :attribute may not be greater than :max:type.'
        });
        SimpleReactValidator.addLocale('sv', {
            required: 'Fältet :attribute krävs.',
            min: ':attribute måste vara minst :min tecken.',
            max: ':attribute kanske inte är större än :max tecken.'
        });
        engValidator = new SimpleReactValidator({
            locale: 'en',
            autoForceUpdate: this
        });
        svValidator = new SimpleReactValidator({
            locale: 'sv',
            autoForceUpdate: this
        });
        this.validator = engValidator;
        engUserInfoValidator = new SimpleReactValidator({
            locale: 'en',
            validators: {
                phoneValidation: {
                    message: 'The phone must be a valid phone number.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(?=.*[0-9])[ ()0-9]+$/) && params.indexOf(val) === -1
                    }
                },
                allowSwedish: {  // name the rule
                    message: 'The :attribute may only contains letters.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[a-zA-Z åäöÅÄÖ!@#\$%\^\&*\)\(+=._-]+$/g) && params.indexOf(val) === -1
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
            }
        });
        svUserInfoValidator = new SimpleReactValidator({
            locale: 'sv',
            validators: {
                phoneValidation: {
                    message: 'Telefonnummer måste vara ett giltigt telefonnummer.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^(?=.*[0-9])[ ()0-9]+$/) && params.indexOf(val) === -1
                    }
                },
                allowSwedish: {  // name the rule
                    message: ':attribute får endast innehålla bokstäver.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^[a-zA-Z åäöÅÄÖ!@#\$%\^\&*\)\(+=._-]+$/g) && params.indexOf(val) === -1
                    },
                    messageReplace: (message, params) => message.replace(':values', this.helpers.toSentence(params)),  // optional
                    required: true  // optional
                },
            }
        });
        this.userInfoValidator = engUserInfoValidator;
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next",nextProps)
        if (nextProps.heartRunnerList.messageLabel !== this.props.heartRunnerList.messageLabel) {

            if (nextProps.heartRunnerList.statusCode == 200) {
                this.notify(nextProps.heartRunnerList.messageLabel)
                this.closeModal();
                this.setState(this.baseState)
                this.validator.hideMessages();
                this.props.getList();
            }
            if (nextProps.heartRunnerList.statusCode == 201) {
                this.errornotify(nextProps.heartRunnerList.messageLabel);
                this.props.getList();
            }
        }

        this.translateLang();
    }
    translateLang() {
        var language;
        if (sessionStorage.getItem('Language')) {
            language = sessionStorage.getItem('Language');
        }
        else {
            language = "en";
        }
        if (language == "en") {
            this.validator = engValidator;
            this.userInfoValidator = engUserInfoValidator;
        }
        else {
            this.validator = svValidator;
            this.userInfoValidator = svUserInfoValidator;
        }
    }
    // closeModal =()=> {
    //     this.setState({ open: false })
    // }
    notify = (message) => {
        swal({ text: message, icon: 'success' })

        // this.toastId =toast.success(message, {
        //   position: toast.POSITION.TOP_CENTER
        // });
    }

    errornotify = (message) => {
        // toast.error(message + "!", {
        //     position: toast.POSITION.TOP_CENTER
        // });
        swal({ text: message, icon: 'error' })

    };
    onDeleteClick(e) {
        const item = e;
        this.toggleSelection(item);
    }



    toggleAll(allDeleteSelected) {
        const deleteSelection = allDeleteSelected ? deleteList : [];
        this.setState({ allDeleteSelected, deleteSelection });
    }


    deleteSelected() {
        const { t } = this.props;
        confirmAlert({
            title: `${t('First_Responder.Confirm to delete')}`,
            message: `${t('First_Responder.Are you sure to delete this?')}`,
            buttons: [
                {
                    label: `${t('First_Responder.Yes')}`,
                    onClick: () => {
                        if (this.state.deleteSelection.length > 0) {
                            // let request = {
                            //     UserId : this.state.deleteSelection[0].UserId
                            // }
                            let requestPayload = [];
                            this.state.deleteSelection.forEach(item => {
                                if (item.UserId) {
                                    requestPayload.push({ UserId: item.UserId })
                                }
                            })
                            this.props.onDelete(requestPayload, this.state.deleteSelection[0].RegionId);
                            this.setState({
                                allDeleteSelected: false,
                                deleteSelection: [],
                                errorDisable: ''
                            });

                        }
                        else {
                            alert(`${t('First_Responder.Please select atleast one device')}`)
                            this.setState({ errorDisable: `${t('First_Responder.Please select atleast one device')}` })
                        }

                    }
                },
                {
                    label: `${t('First_Responder.No')}`,
                    onClick: () => {
                    }
                }
            ]
        });

    }









    openModal = (rowData) => {

        this.setState({ openModal: true })
        this.setState(prevState => ({
            heartRunnerDetails:
            {
                ...prevState.heartRunnerDetails,
                UserId:rowData.UserId,
                RegionId: rowData.RegionId,
                AuthMethodId: rowData.Method,
                AuthTypeId: rowData.Authentication.AuthTypeId
            }
        }),)
       
  let permissionListData = this.props.heartRunnerList.authenticationMethodList
        if (rowData.Authentication.AuthTypeId == 1) {
            this.setState(prevState => ({
                heartRunnerDetails:
                    { ...prevState.heartRunnerDetails, AuthMethodId: [0], AuthMethodList: [] }
            }))
        }
        else {
            {

                this.setState(prevState => ({
                    heartRunnerDetails:
                        { ...prevState.heartRunnerDetails, AuthMethodId: rowData.Method, AuthMethodList: permissionListData }
                }))
            }
        }
       


        

    }
    closeModal = () => {
        this.setState({ openModal: false })
        this.setState(this.baseState)
    }



    getPhoneNumber = (data) => {
        if (data) {
            return '+' + data.CountryCode + data.Phone;
        }
    }
getAuthMethod = (data) => {
        if (data.Authentication) {
            return  data.Authentication.AuthType;
        }
        else
        {
            return ''
        }
    }
    changeRegion = (e) => {
        let value = e.target.value;
        let payload = {
            RegionId: value,
        }
        this.state.RegionId = value.toString();
        this.setState({ RegionId: value.toString() });

        this.props.getUserList(payload)

        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }
    handlePermissionChange = (event) => {


        this.setState(prevState => ({
            heartRunnerDetails:
                { ...prevState.heartRunnerDetails, AuthMethodId: event }
        }))
    }
    permissionType(e) {
        
        let value = e.target.value;
        let name = e.target.name;



        this.setState(prevState => ({
            heartRunnerDetails:
                { ...prevState.heartRunnerDetails, [name]: value }
        }))
        let permissionListData = this.props.heartRunnerList.authenticationMethodList
        if (value == 1) {
            this.setState(prevState => ({
                heartRunnerDetails:
                    { ...prevState.heartRunnerDetails, AuthMethodId: [0], AuthMethodList: [] }
            }))
        }
        else {
            {

                this.setState(prevState => ({
                    heartRunnerDetails:
                        { ...prevState.heartRunnerDetails, AuthMethodId: [], AuthMethodList: permissionListData }
                }))
            }
        }


    }
    actionColumn(rowDatas) {
        const { t } = this.props;
        return (
            <span>
                <span onClick={() => { this.openModal(rowDatas) }} className="enable-cursor editicon" title={t('First_Responder.View')}>
                    <i className="fa fa-lock" aria-hidden="true"></i></span>
            </span>
        )
    }
    updateHeartRunnerDetails = ()=>{
        const { t } = this.props;
  
         
            let heartRunnerInfoData = this.state.heartRunnerDetails;
            
              if(heartRunnerInfoData.RegionId==null || heartRunnerInfoData.RegionId==0 || heartRunnerInfoData.RegionId=='0')
          {
            heartRunnerInfoData.RegionId= this.props.heartRunnerList.regionList[0].ID;
          }
          /*    if(heartRunnerInfoData.UserType==null || heartRunnerInfoData.UserType==0 || heartRunnerInfoData.UserType=='')
          {
            heartRunnerInfoData.UserType= 'Admin';
          } */
          
            let requestPayload = {
             
                RegionId:heartRunnerInfoData.RegionId,
                AuthMethodIds:heartRunnerInfoData.AuthMethodId !=0 ? heartRunnerInfoData.AuthMethodId.map(x=>x.AuthMethodId) :heartRunnerInfoData.AuthMethodId,
            AuthTypeId:parseInt(heartRunnerInfoData.AuthTypeId),
            UserIds:[heartRunnerInfoData.UserId]
            }
          //  this.notify(`${t("First_Responder.Please Sync with dispatcher")}`);
            this.props.onDelete(requestPayload, heartRunnerInfoData.RegionId);
           this.setState({ openModal: false })
             swal(`Auth Settings Updated!`);
        
    }
    render() {
        const { t } = this.props;
        let authenticationTypeListOption;
        let authenticationTypeListVal = this.props.heartRunnerList.authenticationTypeList;
      
        let regionListOption;
        let regionList = this.props.heartRunnerList.regionList;
        if (authenticationTypeListVal) {
            authenticationTypeListOption = authenticationTypeListVal.map((item) =>
                <option style={{ background: '#f5f1f1' }} value={item.AuthTypeId} key={item.AuthTypeId}>{item.AuthType}</option>
            );
        }
        
        if (regionList) {
            regionListOption = regionList.map((item) =>
                <option style={{ background: '#f5f1f1' }} value={item.ID} key={item.ID}>{item.RegionName}</option>
            );
        }
        let orgVal = ['Select', 'Miles', 'Km', 'Meter'];
        let optionDistance;
        optionDistance = orgVal.map((organizationVal, index) =>


            <option value={organizationVal} key={index}>{organizationVal}</option>
        );

        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div >
                <div className="progressbar-heading grids-heading">
                    <h2>Authentication Method Setting</h2>
                </div>
                {/* <ToastContainer /> */}
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <div className="text-left m-b-25 ">


                                    <select id="regionData" style={{ fontSize: 'large', padding: '7px' }}
                                        onChange={this.changeRegion}
                                        placeholder="Select"
                                        ref="regionData"
                                        name={'RegionId'}
                                    >
                                        {regionListOption}
                                    </select>
                                </div>

                                <div className="w3l_search">
                                    {header}
                                </div>
                                <div className="devicestable">


                                    <br />


                                    <DataTable
                                        className="table"
                                        value={this.props.heartRunnerList.heartRunnerList}
                                        loading={this.props.heartRunnerList.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}

                                    // rowClassName={this.rowClassName}

                                    >

                                        <Column field="UserId" header="" className="noDisplay" sortable={true} />
                                        <Column field="DeviceId" header="" className="noDisplay" sortable={true} />

                                        <Column field="FirstName" header={t('First_Responder.First Name')} sortable={true} />
                                        <Column field="LastName" header={t('First_Responder.Last Name')} sortable={true} />
                                       
                                        {/* <Column field="Username" header="User Name" sortable={true} /> */}
                                        <Column body={this.getPhoneNumber} header={t('First_Responder.Phone Number')} className="wordBreakLine" sortable={true} />
                                        <Column field="EmailId" header={t('First_Responder.Email')} className="wordBreakLine" sortable={true} />
                                        {/* <Column field="CertificateId" header={t('First_Responder.Certification ID')} className="wordBreakLine" sortable={true} />                            */}
                                        <Column body={this.getAuthMethod} header={t('Login.Method')} className="wordBreakLine" sortable={true} />
                                        <Column header={t('Login.Auth Method')} body={this.actionColumn}
                                        />


                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Modal open={this.state.openModal} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>Authentication Details</h2>
                        </div>

                        <TabView activeIndex={this.state.activeIndex} className="tabclass tab-respon" onTabChange={(e) => this.setState({ activeIndex: e.index })}>
                            <TabPanel header="Auth Method Details">
                                <div className="">
                                    <div className="forms add-device setting-panel">
                                        <div className="form-three widget-shadow">
                                            <div className=" panel-body-inputin">

                                                <form className="form-horizontal modalForm" >





                                                    <div className="form-group">

                                                        <label className="col-sm-3 control-label">{t('Login.Auth Type')}</label>
                                                        <div className="col-sm-9">
                                                            <div className="input-group">
                                                                <span className="input-group-addon">
                                                                    <i className="" aria-hidden="true"></i>
                                                                </span>
                                                                <select id="AuthTypeId" className="form-control1 "
                                                                    onChange={this.permissionType}
                                                                    value={this.state.heartRunnerDetails.AuthTypeId}
                                                                    placeholder="Select"
                                                                    ref="AuthTypeId"
                                                                    name={'AuthTypeId'}
                                                                >

                                                                    {authenticationTypeListOption}
                                                                </select>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    {
                                                        this.state.heartRunnerDetails.AuthTypeId != 1 ?  <div className="form-group">

                                                        <label className="col-sm-3 control-label">{t('Login.Auth Method')}</label>
                                                        <div className="col-sm-9">
                                                            <div className="input-group">
                                                                <span className="input-group-addon">
                                                                    <i className="" aria-hidden="true"></i>
                                                                </span>
                                                                <Select id="AuthMethodId"
                                                                    className="dropdown"
                                                                    placeholder="Select Option"
                                                                    value={this.state.heartRunnerDetails.AuthMethodId} // set selected values
                                                                    options={this.state.heartRunnerDetails.AuthMethodList} // set list of the data
                                                                    onChange={this.handlePermissionChange} // assign onChange function
                                                                    getOptionLabel={(option) => option.AuthMethod}
                                                                    getOptionValue={(option) => option.AuthMethodId}
                                                                    isMulti
                                                                     isOptionDisabled={() => this.state.heartRunnerDetails.AuthTypeId !=3 ? this.state.heartRunnerDetails.AuthMethodId.length >=1  :null}
                                                                    isClearable
                                                                />
                                                            </div>
                                                        </div>

                                                    </div> : null
                                                    }
                                                  





                                                    <div className="form-group">
                                                        <div className="col-sm-offset-5 col-sm-6">
                                                            <p>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary general-btn"
                                                                    onClick={() => { this.updateHeartRunnerDetails() }}
                                                                >
                                                                    {t('First_Responder.Save')}
                                                                </button>
                                                                {
                                                                    this.props.isLoading ?
                                                                        <i className="fa fa-spinner fa-spin pl-md-2 "></i> : ''
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>


                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </TabPanel>



                        </TabView>
                    </div>
                </Modal>




            </div>
        )
    }
}

export default withNamespaces()(withRouter(UserAuthListComponent));

